import inputfield from '@/modules/form_builder/components/formsComponents/TextField';
import textareafield from '@/modules/form_builder/components/formsComponents/TextArea';
import quantityfield from '@/modules/form_builder/components/formsComponents/Quantity';
import selectfield from '@/modules/form_builder/components/formsComponents/Select';
import radiogroupfield from '@/modules/form_builder/components/formsComponents/RadioGroup';
import datepickerfield from '@/modules/form_builder/components/formsComponents/DatePicker';
import checkboxgroupfield from '@/modules/form_builder/components/formsComponents/CheckboxGroup';
import timepickerfield from '@/modules/form_builder/components/formsComponents/TimePicker';
import { LIST } from '@/modules/form_builder/components/mixins/components-list';

export default {
  components: {
    inputfield,
    selectfield,
    quantityfield,
    radiogroupfield,
    datepickerfield,
    checkboxgroupfield,
    textareafield,
    timepickerfield
  },

  data: () => ({
    elements: LIST
  }),

  methods: {
    fieldName(type) {
      return type + 'field';
    }
  }

};
